<template>
    <section class="g-op">
        <div>
            <h3 class="g-op-title">
                {{ operationType }}

                <span v-if="isVlp">
                    <span v-if="isVlpModification"> (MODIFICATION)</span>
                    <span v-else> (MISE EN PLACE)</span>
                </span>
                <div class="label" :class="stateClass(operation.state)">
                    {{ state(operation.state) }}
                </div>
                <span
                    v-if="['PENDING', 'ERROR'].includes(operation.state)"
                    class="btn btn-link delete"
                    @click.prevent="openDeleteOperation()"
                >
                    Supprimer
                </span>
                <div v-if="saving" class="label label-info">
                    <loader :inline="true"></loader>
                    Sauvegarde
                </div>
            </h3>
            <div
                v-if="
                    [
                        'DEPOSIT',
                        'WITHDRAWAL',
                        'PERIODICPAYMENT',
                        'PERIODICPAYMENTSUSPENSION',
                        'RATTACHEMENT',
                    ].indexOf(operation.type) !== -1
                "
            >
                <h4>
                    #{{ operation.reference_id }}
                    <span v-if="operation.automation_reference">
                        / {{ operation.automation_reference }}
                    </span>
                </h4>

                <h4 v-if="
                    [
                        'PERIODICPAYMENT',
                        'PERIODICPAYMENTSUSPENSION',
                    ].indexOf(operation.type) === -1
                ">
                    {{{ operation.extra.amount | money }}}
                    <span
                        v-if="
                            operation.type === 'RATTACHEMENT'
                            && operation.extra.wire_monthly
                        "
                    >
                        / {{ operation.extra.wire_monthly }}
                        {{ periodicities[operation.extra.wire_period] }}
                    </span>
                </h4>
                <template v-else>
                    <div v-if="operation.type === 'PERIODICPAYMENT'">
                        <h4>
                            <span v-if="isVlpModification">
                                Nouveau Versement :
                            </span>
                            {{{ operation.extra.request.data.versement.amount | money }}} /
                            {{
                                periodicities[
                                    operation.extra.request.data.versement.periodicity]
                            }}
                        </h4>
                        <h4 v-if="isVlpModification">
                            <span>
                                Ancien Versement :
                            </span>
                            {{{ operation.extra.request.data.versement.old.amount | money }}} /
                            {{ periodicities[
                                operation.extra.request.data.versement.old.periodicity
                            ] }}
                        </h4>
                    </div>

                    <div v-else>
                        Ancien Versement :
                        {{{ operation.extra.request.data.versement.amount | money }}} /
                        {{ periodicities[operation.extra.request.data.versement.periodicity] }}
                    </div>
                </template>

            </div>
            <div class="g-op-date">
                {{ date(operation.date_create, 'LL') }}
            </div>
        </div>
        <div class="g-op-error label label-danger"
             v-if="operation.state === 'ERROR'"
        >
            Il y a eu un problème avec l'envoi de la procedure à la
            compagnie. Merci de contacter le support technique.
        </div>

        <div class="row">
            <div
                v-if="documents.length || requirements.length"
                class="panel panel-default"
            >
                <div class="panel-heading"
                     @click="toggleInfo('documentsVisible')">
                    <div>
                        Documents requis
                    </div>

                    <div
                        class="label"
                        :class="stateClass(stepState.documents)"
                    >
                        {{ state(stepState.documents) }}
                    </div>
                </div>

                <table
                    class="table g-op-docs"
                    v-if="documentsVisible"
                >
                    <tr>
                        <th>Type de document</th>
                        <th>Date d'expiration</th>
                        <th>Statut</th>
                        <th>&nbsp;</th>
                    </tr>

                    <tr v-for="doc of documents">
                        <td>
                            <a
                                class="g-op-link"
                                :href="doc.urls.original"
                                target="_blank"
                            >
                                {{
                                    (
                                        types[doc.type] || {name: '???'}
                                    ).name
                                }}
                                <i
                                    class="
                                        glyphicon
                                        glyphicon-download-alt
                                    "
                                ></i>

                                <div class="popover bottom">
                                    <div class="arrow"></div>
                                    <div class="popover-content">
                                        <img
                                            :src="doc.urls.preview['1x']"
                                            :srcset="srcset(doc)"
                                            alt=""
                                        >
                                    </div>
                                </div>
                            </a>
                        </td>

                        <td v-if="level === 'HIGH' && canEdit">
                            <editable-date
                                :value.sync="doc.expiration"
                                :enable-reset="true"
                                placeholder="pas d'expiration"
                            ></editable-date>
                        </td>
                        <td v-else>
                            {{
                                doc.expiration
                                    ? date(doc.expiration, 'LL')
                                    : ''
                            }}
                        </td>

                        <td v-if="level === 'HIGH' && canEdit">
                            <editable-choice
                                :value.sync="doc.state"
                                :options="documentStates"
                            ></editable-choice>
                        </td>
                        <td v-else>
                            {{ stateLabel(doc.state) }}
                        </td>

                        <td v-if="level === 'HIGH' && canEdit">
                            <div class="g-op-popover-parent">
                                <button
                                    class="btn btn-default btn-xs"
                                    @click.prevent="deleteDoc(doc.id)"
                                >
                                    Supprimer
                                </button>

                                <div
                                    class="
                                        popover
                                        fade-transition
                                        left
                                        op-popover-confirm
                                    "
                                    :class="{
                                        '-visible':
                                            docToDelete === doc.id
                                    }"
                                >
                                    <div class="arrow"></div>
                                    <h3 class="popover-title">
                                        Supprimer {{
                                            (
                                                types[doc.type] || {name: '???'}
                                            ).name
                                        }}&nbsp;?
                                    </h3>
                                    <div
                                        class="
                                            popover-content
                                            f
                                            -a-center
                                            -gutter
                                        "
                                    >
                                        <a
                                            @click.prevent="cancelDeleteDoc()"
                                            class="btn btn-link"
                                        >
                                            Annuler
                                        </a>
                                        <a
                                            @click.prevent="confirmDeleteDoc(doc.id)"
                                            class="btn btn-primary"
                                        >
                                            Supprimer
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td v-else>&nbsp;</td>
                    </tr>

                    <tr v-if="canEdit">
                        <td colspan="4">
                            <hr>
                        </td>
                    </tr>

                    <tr v-for="req of requirements">
                        <td class="g-op-doc-type-missing" colspan="3">
                            {{ docTypeFromAuto[req.automation_type].name }}
                        </td>
                        <td v-if="level === 'HIGH' && canEdit">
                            <button
                                class="btn btn-default btn-xs"
                                @click.prevent="openAddDocument(req.automation_type)"
                            >
                                Ajouter
                            </button>
                        </td>
                        <td v-else>&nbsp;</td>
                    </tr>

                    <tr v-if="level === 'HIGH' && canEdit">
                        <td colspan="3">
                            Autre type de document...
                        </td>
                        <td>
                            <button
                                class="btn btn-default btn-xs"
                                @click.prevent="openAddDocument()"
                            >
                                Ajouter
                            </button>
                        </td>
                    </tr>
                </table>
            </div>

            <div v-if="operation.type === 'SUBSCRIPTION'">
                <div
                        class="panel panel-default"
                        v-if="automation !== 'paper'"
                    >
                        <div class="panel-heading"
                             @click="toggleInfo('signatureVisible')">
                            <div>
                                Signature du contrat
                            </div>

                            <div
                                class="label"
                                :class="stateClass(stepState.signature)"
                            >
                                {{ state(stepState.signature) }}
                            </div>
                        </div>

                        <table
                            class="table"
                            v-if="signatureVisible"
                        >
                            <tr>
                                <th>Type de document</th>
                            </tr>

                            <tr v-for="doc of documentsToSign">
                                <td>
                                    <a
                                    class="g-op-link"
                                    :href="(doc.urls_signed || {}).original || doc.urls.original"
                                    target="_blank"
                                    >
                                        {{
                                            (
                                                types[doc.type] || {name: '???'}
                                            ).name
                                        }}
                                        <i
                                            class="
                                                glyphicon
                                                glyphicon-download-alt
                                            "
                                        ></i>

                                        <div class="popover bottom">
                                            <div class="arrow"></div>
                                            <div class="popover-content">
                                                <img
                                                    :src="doc.urls.preview['1x']"
                                                    :srcset="srcset(doc)"
                                                    alt=""
                                                >
                                            </div>
                                        </div>
                                    </a>
                                </td>
                            </tr>
                        </table>

                        <div class="panel-body" v-if="signatureVisible">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="media">
                                    <div class="media-body">
                                        <h4 class="media-heading">
                                            {{ operation.contact.first_name }}
                                            {{ operation.contact.last_name }}
                                        </h4>

                                        <template
                                            v-if="operation.signature_member_date">
                                            Signé le
                                            {{
                                                date(operation.signature_member_date, 'LLLL')
                                            }}
                                        </template>
                                        <template v-else>
                                            Non signé
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <div class="media">
                                    <div class="media-body">
                                        <h4 class="media-heading">
                                            Grégoire Dauge
                                        </h4>

                                        <template
                                            v-if="operation.signature_alpinia_date">
                                            {{ signatureVerb }} le
                                            {{
                                                date(operation.signature_alpinia_date, 'LLLL')
                                            }}
                                        </template>
                                        <template v-else>
                                            <template
                                                v-if="level === 'HIGH'  && canEdit">
                                                <button
                                                    v-if="stepState.documents === 'DONE'"
                                                    class="btn btn-primary"
                                                    @click.prevent="showYousign()"
                                                >
                                                    Valider
                                                </button>
                                                <div v-else>
                                                    Compléter les documents pour
                                                    valider
                                                </div>
                                            </template>
                                            <template v-else>
                                                Non validé
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else class="panel panel-default">
                    <div class="panel-heading">
                        <div>
                            Signature du contrat
                        </div>

                        <div
                            class="label"
                            :class="stateClass(stepState.signature)"
                        >
                            {{ state(stepState.signature) }}
                        </div>
                    </div>

                    <div class="panel-body" v-if="signatureVisible">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="media">
                                    <div class="media-body">
                                        <h4 class="media-heading">
                                            {{ operation.contact.first_name }}
                                            {{ operation.contact.last_name }}
                                        </h4>

                                        <editable-date
                                            v-if="canEdit && level === 'HIGH'"
                                            placeholder="Non signé"
                                            :value.sync="
                                                    operation.signature_member_date
                                                "
                                            :enable-reset="true"
                                        ></editable-date>
                                        <template v-else>
                                            <template
                                                v-if="operation.signature_member_date"
                                            >
                                                Signé le
                                                {{
                                                    date(
                                                        operation.signature_member_date,
                                                        'LLLL'
                                                    )
                                                }}
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <div class="media">
                                    <div class="media-body">
                                        <h4 class="media-heading">
                                            Grégoire Dauge
                                        </h4>

                                        <editable-date
                                            v-if="canEdit && level === 'HIGH'"
                                            placeholder="Non signé"
                                            :value.sync="
                                                    operation.signature_alpinia_date
                                                "
                                            :enable-reset="true"
                                        ></editable-date>
                                        <template v-else>
                                            <template
                                                v-if="operation.signature_alpinia_date"
                                            >
                                                Signé le
                                                {{
                                                    date(
                                                        operation.signature_alpinia_date,
                                                        'LLLL'
                                                    )
                                                }}
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <operation-saxo
                v-if="operation.type === 'SUBSCRIPTION' && contract.from_saxo"
                :operation="operation"
                :signature-done="stepState.signature === 'DONE'"
                @saxo="watchForAutomation()"
            ></operation-saxo>

            <div v-else>
                <div v-if="operation.type !== 'RATTACHEMENT'" class="panel panel-default">
                    <div class="panel-heading" @click="toggleInfo('companySendVisible')">
                        <div>
                            Envoi à la compagnie
                        </div>

                        <div
                            class="label"
                            :class="stateClass(stepState.automation)"
                        >
                            {{ state(stepState.automation) }}
                        </div>
                    </div>

                    <ul
                        v-if="companySendVisible && operation.automation_call.length"
                        class="list-group"
                    >
                        <li
                            v-for="call of operation.automation_call"
                            class="list-group-item"
                        >
                            <h4 v-if="call.success">
                                Succès
                                <small>{{ date(call.date, 'LLL') }}</small>
                            </h4>
                            <h4 v-else>
                                Erreur
                                <small>{{ date(call.date, 'LLL') }}</small>
                            </h4>

                            <template v-if="call.fields.length">
                                <h5>Valeurs</h5>

                                <ul>
                                    <li v-for="field of call.fields">
                                        <strong>{{ field.label }}</strong>&nbsp;:
                                        {{ field.value }}
                                    </li>
                                </ul>
                            </template>

                            <template v-if="call.errors.length">
                                <h5>Erreurs</h5>

                                <ul>
                                    <li v-for="error of call.errors">
                                        {{ error.message }}
                                    </li>
                                </ul>
                            </template>
                        </li>
                    </ul>

                    <div v-if="level === 'HIGH' && canRetry"
                         class="panel-body"
                    >
                        <button
                            v-if="!automationIsLoading"
                            @click="restartAutomation()"
                            class="btn btn-primary"
                            :class="{disabled: !canSubmitToAutomation}"
                        >
                            Essayer à nouveau
                        </button>
                        <div v-else>
                            <loader :inline="true"></loader>
                            Envoi en cours
                        </div>
                    </div>
                    <div v-else>
                        <div
                            v-if="
                                    stepState.automation === 'PENDING' &&
                                    level === 'HIGH'
                                "
                            class="panel-body"
                        >
                            <button
                                v-if="!automationIsLoading"
                                @click="startAutomation()"
                                class="btn btn-primary"
                                :class="{disabled: !canSubmitToAutomation}"
                            >
                                Envoyer à la compagnie
                            </button>
                            <div v-else>
                                <loader :inline="true"></loader>
                                Envoi en cours
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <yousign-modal
            v-ref:yousign
            :operation="operation"
        ></yousign-modal>

        <modal :show.sync="showAddDocument">
            <div class="modal-header" slot="modal-header">
                <h4>Ajout d'un document</h4>
            </div>

            <div class="modal-body" slot="modal-body">
                <div class="form-horizontal">
                    <div class="form-group">
                        <label
                            :for="'document-upload-file-' + _uid"
                            class="col-sm-2 control-label"
                        >
                            Fichier
                        </label>
                        <div class="col-sm-9 checkbox">
                            <editable-file
                                :info.sync="addDocument.file"
                            ></editable-file>
                        </div>
                    </div>
                    <div class="form-group">
                        <label
                            :for="'document-upload-type-' + _uid"
                            class="col-sm-2 control-label"
                        >
                            Type
                        </label>
                        <div class="col-sm-9 checkbox">
                            <editable-choice
                                :id="'document-upload-type-' + _uid"
                                placeholder="—"
                                :enable-reset="false"
                                :value.sync="addDocument.type"
                                :options="documentTypeChoices"
                            ></editable-choice>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer" slot="modal-footer">
                <button
                    @click.prevent="cancelAddDocument()"
                    class="btn btn-link"
                >
                    Annuler
                </button>
                <button
                    @click.prevent="doAddDocument()"
                    :class="{disabled: !addDocumentValid}"
                    class="btn btn-primary"
                >
                    Sauvegarder
                </button>
            </div>
        </modal>

        <modal :show.sync="showDeleteOperation">
            <div class="modal-header" slot="modal-header">
                <h4>Supprimer l'operation</h4>
            </div>

            <div class="modal-body" slot="modal-body">
                Êtes-vous sûr de vouloir supprimer cette opération ?
            </div>

            <div class="modal-footer" slot="modal-footer">
                <loader v-if="deletingOperation" :inline="true"></loader>
                <div v-else>
                    <button
                        @click.prevent="cancelDeleteOperation()"
                        class="btn btn-default"
                    >
                        Non
                    </button>
                    <button
                        @click.prevent="doDeleteOperation()"
                        class="btn btn-primary"
                    >
                        Oui
                    </button>
                </div>
            </div>
        </modal>
    </section>
</template>

<style lang="less">
@import "../../style/variables";

@preview-width: 350px;

.g-op {
    /**
     * Relying on Bootstrap's style but just adjusting some margins
     */

    &-title {
        margin-bottom: 5px;

        .label {
            margin-left: 10px;
        }

        .delete {
            margin-left: 10px;
        }
    }

    &-error {
        margin-bottom: 1em;
        padding: .6em .6em;
        display: flex;
        font-size: 1.1em;
    }

    /**
     * Made-up text style to have a muted out date
     */

    &-date {
        font-size: 110%;
        opacity: 0.7;
        margin: 0 0 20px;
    }

    /**
     * Relying on Bootstrap's style for the link style, however there is a lot
     * of placement and sizing done for the preview popover
     */

    &-link {
        position: relative;

        .popover {
            display: block;
            visibility: hidden;
            opacity: 0;

            top: 100%;
            left: 6px;
            transform: translateX(-50%);

            transition: ease all 200ms;
            transition-delay: 0ms;
            max-width: @preview-width + 30px;
        }

        &:hover .popover {
            visibility: visible;
            opacity: 1;
            transition-delay: 300ms;
        }

        img {
            width: @preview-width;
        }
    }

    /**
     * Setting up fixed column sizes to avoid jumps on edits
     */

    &-docs {
        /**
         * There is a little specificity hack there to overthrow Bootstrap's
         * tables alignment.
         */

        &&&&& td {
            vertical-align: middle;
        }

        th:nth-child(2) {
            width: 200px;
        }

        th:nth-child(3) {
            width: 110px;
        }

        th:nth-child(4) {
            width: 90px;
        }

        /**
         * Align buttons to the right
         */

        td:nth-child(4),
        td[colspan="3"]:nth-child(1) + td:nth-child(2) {
            text-align: right;
        }
    }

    /**
     * Coloring in red missing documents
     */

    &-doc-type-missing {
        color: @brand-danger;
    }

    /**
     * Override something from Bootstrap that we don't need (probably float-
     * related) because it hides the datepicker.
     */

    .media,
    .media-body {
        overflow: visible;
    }
}

/**
 * Parent div for the popover to position relatively to
 */
.g-op-popover-parent {
    position: relative;
}

/**
 * Confirmation popover styling and animation
 */
.popover.op-popover-confirm {
    display: block;
    position: absolute;
    right: ~"calc(100% + 12px)";
    left: auto;
    top: 50%;
    transform: translateY(-50%);
    transition: ease 300ms;
    visibility: hidden;
    opacity: 0;

    &.-visible {
        visibility: visible;
        opacity: 1;
    }
}

/**
 * Panel heading style to expand/collapse info and flexbox layout
 */
.panel-heading {
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
}
</style>

<script>
import {ObjectDebounce} from 'wasync';
import Modal from 'vue-strap/src/Modal';
import Loader from '../Loader';
import {manager as msgManager} from '../../messages';
import EditableFile from '../editable/EditableFile';
import EditableDate from '../editable/EditableDate';
import EditableChoice from '../editable/EditableChoice';
import OperationSaxo from './OperationSaxo.vue';
import YousignModal from './YousignModal';
import api from '../../api/core';
import {
    setExpiration,
    setState,
    setSignatures,
    documentStates,
    deleteDocument,
    addDocument,
    submitContract,
    submitOperation,
    deleteOperation,
    getOperation, retryOperation
} from '../../api/operations';
import {fetch as fetchContract} from '../../api/contract';
import {seeLatest, updateCount} from '../../api/todo';
import {sleep} from '../../utils';
import router from '../../router';

/**
 * Second-order function to auto-commit changes made to the documents according
 * to the diff with the data that was retrieved from the API.
 *
 * @param prop {String} Name of the prop for wasync's debouncer
 * @param setter {Function} Function that will set the value in the API
 * @param persistAttr {String} Name of the attribute where the API's values
 *                             are persisted
 * @param extractFunc {String} Name of the function that will extract the
 *                             values from API data in order to persist them
 * @param successMessage {String} What to display in the toast on success
 * @param savingAttr {String} Toggle this attribute to true while saving
 */
function autoCommit({
                        prop,
                        setter,
                        persistAttr,
                        extractFunc,
                        successMessage,
                        savingAttr
                    }) {
    return new ObjectDebounce({wait: 0, prop}).func({
        validate(diff) {
            if (!diff.length) {
                return false;
            }

            return {diff: [...diff]};
        },

        prepare() {
            this[savingAttr] = true;
        },

        cleanup() {
            this[savingAttr] = false;
        },

        async run({diff}) {
            let operation;

            for (const d of diff) {
                operation = await setter(d);
            }

            return {operation};
        },

        success({operation}) {
            this[persistAttr] = this[extractFunc](operation);
            Object.assign(this.operation, operation);
            msgManager.push('Succès', successMessage, 'success');
        },

        failure(err) {
            msgManager.push('Erreur', err, 'danger');
        }
    });
}

export default {
    components: {
        Modal,
        YousignModal,
        OperationSaxo,
        EditableFile,
        EditableDate,
        EditableChoice,
        Loader
    },

    props: {
        /**
         * Contract object as returned by the API
         */
        contract: {
            required: true
        },

        /**
         * Operation object as returned from the API
         */
        operation: {
            required: true
        }
    },

    data() {
        return {
            /**
             * Indicates if the component still exists so that polling loops
             * can know when to stop.
             */
            run: true,

            /**
             * Controls the display of the delete confirmation popover
             */
            docToDelete: null,

            /**
             * Cache of dates that were returned by the API (so we can diff
             * values and know what to save)
             */
            persistedDates: {},

            /**
             * Cache of states that were returned by the API (so we can diff
             * values and know what to save)
             */
            persistedStates: {},

            /**
             * Cache the signature dates for paper mode
             */
            persistedPaperSignatures: [],

            /**
             * Indicates that dates are currently being saved
             */
            savingDates: false,

            /**
             * Indicates that states are currently being saved
             */
            savingStates: false,

            /**
             * Indicates that signatures are being saved
             */
            savingSignatures: false,

            /**
             * Indicates that states are currently being saved
             */
            deletingDocument: false,

            /**
             * Indicates that states are currently being saved
             */
            addingDocument: false,

            /**
             * The polling to know if automation is done has started
             */
            doingAutomation: false,

            /**
             * Indicates if the modal to add a document is displayed
             */
            showAddDocument: false,

            /**
             * Indicates if the modal to delete an operation is displayed
             */
            showDeleteOperation: false,

            /**
             * Indicates that states are currently being saved
             */
            deletingOperation: false,

            /**
             * Add document form data
             */
            addDocument: {
                file: null,
                type: null
            },

            /**
             * Show/hide documents table
             */
            documentsVisible: false,

            /**
             * Show/hide signature table
             */
            signatureVisible: false,

            /**
             * Show/hide send to company table
             */
            companySendVisible: false,

            /**
             * Periodicities object to be correctly rendered
             */
            periodicities: {
                MONTHLY: 'Mensuel',
                QUARTERLY: 'Trimestriel',
                BIANNUALLY: 'Semestriel',
                ANNUALLY: 'Annuel'
            }
        };
    },

    computed: {
        /**
         * Current level of the user
         */
        level: api.getLevel,

        /**
         * Automation mode for this operation
         // */
        automation() {
            return this.contract.automation;
        },

        /**
         * Shortcut to the operation's contact
         */
        contact() {
            return this.operation.contact;
        },

        /**
         * Indexed known document types
         */
        types() {
            const out = {};

            for (const {id, name, automation_code} of this.operation.types) {
                out[id] = {name, automation_code};
            }

            return out;
        },

        /**
         * Shortcut to the documents
         */
        documents() {
            return this.operation.documents;
        },

        /**
         * Shortcut to the documents to be signed
         */
        documentsToSign() {
            return this.operation.documents_to_sign;
        },

        /**
         * Combines classical documents and documents to sign in order to
         * compute compliance with the requirements.
         */
        combinedDocs() {
            return [
                ...this.operation.documents,
                ...this.operation.documents_to_sign
            ];
        },

        /**
         * Counts the amount of each document type present. This will also
         * include the documents to be signed, which are not displayed in the
         * first documents block, because obviously if they are present in the
         * "to be signed" section they will indeed be available when sending
         * documents through the API.
         */
        present() {
            return this.combinedDocs.reduce((out, doc) => {
                const code = (this.docTypeFromId[doc.type] || {}).automation_code;

                if (code) {
                    out[code] = (out[code] || 0) + 1;
                }

                return out;
            }, {});
        },

        /**
         * Requirements that are not fulfilled yet
         */
        requirements() {
            return this.operation
                .requirements
                .filter(({min, max, automation_type}) => {
                    const present = this.present[automation_type] || 0;
                    return !(min <= present && present <= max);
                });
        },

        /**
         * Computes the current state of the various stages of the operation
         */
        stepState() {
            return {
                documents: this.operation.stages.documents,
                signature: this.operation.stages.signature,
                automation: this.operation.stages.automation
            };
        },

        /**
         * If the two previous stages are validated then let's allow to submit
         * automation
         */
        canSubmitToAutomation() {
            return this.stepState.documents === 'DONE' &&
                this.stepState.signature === 'DONE';
        },

        /**
         * Extracted dates from the front-end values, to be compared with
         * the API values
         */
        frontEndDates() {
            return this.extractDocumentsDates(this.operation);
        },

        /**
         * Extracted states from the front-end values, to be compared with
         * the API values
         */
        frontEndStates() {
            return this.extractDocumentsStates(this.operation);
        },

        /**
         * Currently displayed signature dates
         */
        frontEndPaperSignatures() {
            return this.extractSignatureDates(this.operation);
        },

        /**
         * Diff between API and front-end dates, watched in order to send the
         * updates to the API
         */
        datesDiff() {
            return this.attrDiff('persistedDates', 'frontEndDates', 'expiration');
        },

        /**
         * Diff between API and front-end states, watched in order to send the
         * updates to the API
         */
        statesDiff() {
            return this.attrDiff('persistedStates', 'frontEndStates', 'state');
        },

        /**
         * Generates the diff commands to save the signature dates when in
         * paper mode.
         */
        signatureDiff() {
            if (this.automation !== 'paper') {
                return [];
            }

            const old = this.persistedPaperSignatures;
            const now = this.frontEndPaperSignatures;

            if (old[0] !== now[0] || old[1] !== now[1]) {
                return [{
                    operation: this.operation.id,
                    signatures: now
                }];
            }

            return [];
        },

        /**
         * Mapping document types from automation codes
         */
        docTypeFromAuto() {
            return this.operation.types.reduce((out, type) => {
                out[type.automation_code] = type;
                return out;
            }, {});
        },

        /**
         * Mapping document types from IDs
         */
        docTypeFromId() {
            return this.operation.types.reduce((out, type) => {
                out[type.id] = type;
                return out;
            }, {});
        },

        /**
         * Aggregated saving flag
         */
        saving() {
            return this.savingDates ||
                this.savingStates ||
                this.deletingDocument ||
                this.addingDocument ||
                this.savingSignatures;
        },

        /**
         * Available document states
         */
        documentStates,

        /**
         * EditableChoice-compatible list of choices for document types
         */
        documentTypeChoices() {
            return this.operation.types.map(
                ({id, name}) => ({value: `${id}`, label: name})
            );
        },

        /**
         * Indicates if the add document form's data is valid
         */
        addDocumentValid() {
            return this.addDocument.type &&
                this.addDocument.file &&
                this.addDocument.file.id;
        },

        signatureVerb() {
            if (this.stepState.signature === 'CANCELED') {
                return 'Rejetté';
            } else {
                return 'Validé';
            }
        },

        /**
         * Automation can either be loading because it's said so in the
         * operation (as received from the server) or because the user clicked
         * the button to start it (aka what happens client-side). This is so
         * that if the operation is still ongoing and the user refreshes the
         * page they'll keep on seeing it loading and won't be able to click
         * the damn button.
         */
        automationIsLoading() {
            return this.operation.automation_state === 'WORKING' ||
                this.doingAutomation;
        },

        /**
         * Forbids edition when the operation is being submitted or has been
         * successfully submitted, as at this point it is sent and you cannot
         * go back.
         */
        canEdit() {
            const res = this.operation.state === 'PENDING' &&
                !this.automationIsLoading;
            return res;
        },

        canRetry() {
            return this.operation.state === 'ERROR' &&
                [
                    'DEPOSIT',
                    'WITHDRAWAL',
                    'PERIODICPAYMENT',
                    'PERIODICPAYMENTSUSPENSION'
                ].includes(this.operation.type);
        },

        /**
         * Determines if operation is a periodic payment.
         */
        isVlp() {
            if (this.operation.extra.request) {
                return this.operation.extra.request.type.toUpperCase() === 'PERIODICPAYMENT';
            }
            return false;
        },

        /**
         * For periodic payments, determines if it's a modification or not
         */
        isVlpModification() {
            return (
                this.isVlp &&
                this.operation.extra.request.data.versement.is_modification
            );
        },

        /**
         * Returns the specific operation type, including Saxo Migration.
         */
        operationType() {
            if (this.operation.type === 'SUBSCRIPTION' && this.contract.from_saxo) {
                return 'SAXO MIGRATION';
            }
            return {
                SUBSCRIPTION: 'SOUSCRIPTION',
                DEPOSIT: 'VERSEMENT LIBRE',
                WITHDRAWAL: 'RACHAT PARTIEL',
                PERIODICPAYMENT: 'VERSEMENT LIBRE PROGRAMMÉ',
                PERIODICPAYMENTSUSPENSION: 'VERSEMENT LIBRE PROGRAMMÉ (ARRÊT)',
                RATTACHEMENT: 'RATTACHEMENT CONTRAT'
            }[this.operation.type];
        }
    },

    methods: {
        /**
         * Formats a date. We could use filters but since the feature got
         * removed in future versions of Vue that would not be future proof
         * so let's start to behave like we're going to upgrade.
         */
        date(...args) {
            return this.$options.filters.date(...args);
        },

        /**
         * Given a state, returns the label of that state
         */
        state(state) {
            return {
                PENDING: 'À traiter',
                DONE: 'Fait',
                CANCELED: 'Annullée',
                ERROR: 'Erreur'
            }[state];
        },

        /**
         * Given a state, returns the class of that state
         */
        stateClass(state) {
            return {
                PENDING: 'label-warning',
                DONE: 'label-success',
                CANCELED: 'label-danger',
                ERROR: 'label-danger'
            }[state];
        },

        /**
         * Transforms the list of documents into a dictionary with as key the
         * document's ID and as value the specified attribute.
         *
         * @param operation {Object} Operation to scan
         * @param attr {String} Attribute to be indexed
         */
        extractDocumentsAttr(operation, attr) {
            return operation
                .documents
                .reduce((out, doc) => {
                    out[doc.id] = doc[attr];
                    return out;
                }, {});
        },

        /**
         * Makes an index of dates by document
         */
        extractDocumentsDates(operation) {
            return this.extractDocumentsAttr(operation, 'expiration');
        },

        /**
         * Makes an index of states by document
         */
        extractDocumentsStates(operation) {
            return this.extractDocumentsAttr(operation, 'state');
        },

        /**
         * Extracts just the signature dates, for paper mode
         */
        extractSignatureDates(operation) {
            /**
             * Makes sure that we deal with a date and not a date time,
             * otherwise Django gets confused
             */
            function safe(x) {
                if (/\d{4}-\d{2}-\d{2}/.test(x || '')) {
                    return x.substr(0, 10);
                }

                return null;
            }

            return [
                safe(operation.signature_alpinia_date),
                safe(operation.signature_member_date)
            ];
        },

        /**
         * Computes the difference between two indices, typically between
         * what is cached from the API and what is currently being displayed
         * in the front-end.
         *
         * @param persisted {String} Name of the attribute containing the cache
         * @param front {String} Name of the attribute containing live values
         * @param attr {String} Name of the attribute to index
         */
        attrDiff(persisted, front, attr) {
            const out = [];

            for (const [key, value] of Object.entries(this[persisted])) {
                if (value !== this[front][key]) {
                    const obj = {document: key};
                    obj[attr] = this[front][key];
                    out.push(obj);
                }
            }

            return out;
        },

        /**
         * Shortcut to compute srcsets for previews
         */
        srcset(doc) {
            return `${doc.urls.preview['1x']}, ${doc.urls.preview['2x']} 2x`;
        },

        /**
         * Finds the right label for a document state
         */
        stateLabel(state) {
            return documentStates().find(x => x.value === state).label;
        },

        /**
         * Asks for the confirmation of the document's deletion
         */
        deleteDoc(docId) {
            this.docToDelete = docId;
        },

        /**
         * Cancels the document's deletion
         */
        cancelDeleteDoc() {
            this.docToDelete = null;
        },

        /**
         * Confirms the document's deletion and effectuates the change
         */
        confirmDeleteDoc: new ObjectDebounce({wait: 0, prop: '_delete'}).func({
            validate(docId) {
                if (!docId) {
                    return false;
                }

                return {docId};
            },

            prepare() {
                this.deletingDocument = true;
            },

            cleanup() {
                this.deletingDocument = false;
            },

            async run({docId}) {
                const operation = await deleteDocument({document: docId});
                return {operation};
            },

            /**
             * Upon success, let's not forget to update the current operation
             * but also the cached dates and states so that the auto-commit
             * code does not go nuts.
             */
            success({operation}) {
                this.persistAll(operation);
                Object.assign(this.operation, operation);
                msgManager.push('Succès', 'Document supprimé', 'success');
                this.docToDelete = null;
            },

            /**
             * Upon failure, just display a message
             */
            failure(err) {
                msgManager.push('Erreur', err, 'danger');
            }
        }),

        /**
         * Opens the add document modal. If an automation type is specified
         * then document type will be pre-selected
         */
        openAddDocument(automationType) {
            this.showAddDocument = true;
            this.addDocument = {file: null, type: null};

            if (automationType) {
                this.addDocument.type =
                    `${this.docTypeFromAuto[automationType].id}`;
            }
        },

        /**
         * Hides the document-adding modal
         */
        cancelAddDocument() {
            this.showAddDocument = false;
        },

        /**
         * Confirms the document's deletion and effectuates the change
         */
        doAddDocument: new ObjectDebounce({wait: 0, prop: '_add'}).func({
            validate() {
                if (!this.addDocumentValid || this.addingDocument) {
                    return false;
                }

                return {
                    file: this.addDocument.file.id,
                    type: this.addDocument.type
                };
            },

            prepare() {
                this.addingDocument = true;
            },

            cleanup() {
                this.addingDocument = false;
            },

            async run({file, type}) {
                const operation = await addDocument({
                    operation: this.operation.id,
                    file,
                    type
                });
                return {operation};
            },

            /**
             * Upon success, let's not forget to update the current operation
             * but also the cached dates and states so that the auto-commit
             * code does not go nuts.
             */
            success({operation}) {
                this.persistAll(operation);
                Object.assign(this.operation, operation);
                msgManager.push('Succès', 'Document ajouté', 'success');
                this.showAddDocument = false;
            },

            /**
             * Upon failure, just display a message
             */
            failure(err) {
                msgManager.push('Erreur', err, 'danger');
            }
        }),

        /**
         * Shows the operation-deleting modal
         */
        openDeleteOperation() {
            this.showDeleteOperation = true;
        },

        /**
         * Hides the operation-deleting modal
         */
        cancelDeleteOperation() {
            this.showDeleteOperation = false;
        },

        /**
         * Confirms the operation's deletion and effectuates the deletion.
         *
         * If success, it saves an attribute in the localStorage, in order to
         * show a message in the to do page when redirected there.
         */
        doDeleteOperation: new ObjectDebounce({wait: 0}).func({
            validate() {
                return true;
            },

            prepare() {
                this.deletingOperation = true;
            },

            cleanup() {
                this.deletingOperation = false;
                this.showDeleteOperation = false;
            },

            async run() {
                await deleteOperation({ operation: this.operation.id });
            },

            success() {
                localStorage.setItem('opDel', 'true');
                router.replace({name: 'todo-list'});
            },

            failure(err) {
                msgManager.push('Erreur', err, 'danger');
            }
        }),

        /**
         * Triggers the display of the YouSign modal
         */
        showYousign() {
            this.$refs.yousign.display(this.operation.signature_url);
        },

        /**
         * Starts the automation process for this operation. This will first
         * start the automation and then start the polling to know when the
         * automation is done.
         */
        startAutomation: new ObjectDebounce({wait: 0}).func({
            validate() {
                return !this.automationIsLoading && this.canSubmitToAutomation;
            },

            prepare() {
                this.doingAutomation = true;
            },

            cleanup() {
                this.doingAutomation = false;
            },

            async run() {
                const ops = [
                    'DEPOSIT',
                    'WITHDRAWAL',
                    'PERIODICPAYMENT',
                    'PERIODICPAYMENTSUSPENSION'
                ];
                if (ops.indexOf(this.operation.type) > -1) {
                    await submitOperation({operation: this.operation.id});
                } else if (this.operation.type === 'SUBSCRIPTION') {
                    await submitContract({operation: this.operation.id});
                }
                await this.watchForAutomation();

                if (this.stepState.automation !== 'DONE') {
                    throw 'Demande refusée par la compagnie';
                }
            },

            success() {
                msgManager.push(
                    'Succès',
                    'La compagnie a accepté le dossier',
                    'success'
                );
            },

            failure(err) {
                msgManager.push(
                    'Erreur',
                    err,
                    'danger'
                );
            }
        }),

        /**
         * Starts the automation process for this operation. This will first
         * start the automation and then start the polling to know when the
         * automation is done.
         */
        restartAutomation: new ObjectDebounce({wait: 0}).func({
            validate() {
                return !this.automationIsLoading && this.canSubmitToAutomation;
            },

            prepare() {
                this.doingAutomation = true;
            },

            cleanup() {
                this.doingAutomation = false;
            },

            async run() {
                if ([
                    'DEPOSIT',
                    'WITHDRAWAL',
                    'PERIODICPAYMENT',
                    'PERIODICPAYMENTSUSPENSION'
                ].indexOf(this.operation.type) > -1) {
                    await retryOperation({operation: this.operation.id});
                }
                await this.watchForAutomation();

                if (this.operation.state !== 'PENDING') {
                    throw 'La demande ne peut pas être relancée';
                }
            },

            success() {
                msgManager.push(
                    'Succès',
                    'Demande relancée',
                    'success'
                );
            },

            failure(err) {
                msgManager.push(
                    'Erreur',
                    err,
                    'danger'
                );
            }
        }),

        /**
         * Waiting for the automation status to go back to idle. When this
         * happens, the displayed operation is updated with what the server
         * provides.
         *
         * Reloading the page is necessary to correctly display the allocation
         * name instead of its ID when the information is updated.
         */
        async watchForAutomation() {
            for (let i = 0; i < 1000 && this.run; i += 1) {
                const op = await getOperation({operation: this.operation.id});

                if (op.automation_state === 'IDLE') {
                    Object.assign(this.operation, op);

                    const {automation} = this.stepState;
                    if (automation === 'DONE') {
                        Object.assign(
                            this.contract,
                            await fetchContract(this.contract.id)
                        );
                        window.location.reload();
                    } else if (automation === 'ERROR') {

                    }

                    updateCount();

                    return;
                }

                await sleep(1000);
            }

            throw new Error('La compagnie ne répond pas');
        },

        /**
         * Runs all the caching procedures for diff purposes.
         */
        persistAll(op) {
            this.persistedDates = this.extractDocumentsDates(op);
            this.persistedStates = this.extractDocumentsStates(op);
            this.persistedPaperSignatures = this.extractSignatureDates(op);
        },

        /**
         * Expand/collapse block info
         */
        toggleInfo(prop) {
            this[prop] = !this[prop];
        }
    },

    /**
     * On ready make a few sanity checks and then cache values from the API
     */
    ready() {
        const validOperations = [
            'SUBSCRIPTION',
            'DEPOSIT',
            'WITHDRAWAL',
            'PERIODICPAYMENT',
            'PERIODICPAYMENTSUSPENSION',
            'RATTACHEMENT'
        ];
        if (!validOperations.includes(this.operation.type)) {
            throw new Error(
                `Operation type ${this.operation.type} is not supported`
            );
        }

        this.persistAll(this.operation);

        if (this.automationIsLoading) {
            this.watchForAutomation();
        }

        seeLatest();

        /**
         * Expand/collapse blocks depending of their status
         */
        this.documentsVisible = this.state(this.stepState.documents).toUpperCase() !== 'FAIT';
        this.signatureVisible = this.state(this.stepState.signature).toUpperCase() !== 'FAIT';
        this.companySendVisible = this.state(this.stepState.automation).toUpperCase() !== 'FAIT';
    },

    /**
     * Stop running polls
     */
    beforeDestroy() {
        this.run = false;
    },

    watch: {
        /**
         * Auto-commits date changes into the API
         */
        datesDiff: autoCommit({
            prop: '_dates',
            setter: setExpiration,
            persistAttr: 'persistedDates',
            extractFunc: 'extractDocumentsDates',
            successMessage: 'Date enregistrée',
            savingAttr: 'savingDates'
        }),

        /**
         * Auto-commits state changes into the API
         */
        statesDiff: autoCommit({
            prop: '_states',
            setter: setState,
            persistAttr: 'persistedStates',
            extractFunc: 'extractDocumentsStates',
            successMessage: 'Statut enregistrée',
            savingAttr: 'savingStates'
        }),

        /**
         * Auto-commits signature changes into the API (only in paper mode)
         */
        signatureDiff: autoCommit({
            prop: '_sign',
            setter: setSignatures,
            persistAttr: 'persistedPaperSignatures',
            extractFunc: 'extractSignatureDates',
            successMessage: 'Signatures changées',
            savingAttr: 'savingSignatures'
        })
    }
};
</script>



// WEBPACK FOOTER //
// Operation.vue?1267a725